"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fill: "#016FD0",
      fillRule: "evenodd",
      d: "M2.709 8 0 14.991h3.243l.402-1.115h.918l.402 1.115h3.57v-.85l.318.85h1.846l.318-.869v.869h7.423l.902-1.086.846 1.086L24 15l-2.717-3.485L24 8h-3.753l-.879 1.066L18.549 8h-8.075l-.693 1.804L9.07 8H5.835v.822L5.475 8H2.71Zm.627.993h1.58l1.797 4.74v-4.74h1.732l1.387 3.399 1.28-3.4h1.722v5.017h-1.048l-.009-3.93-1.528 3.93h-.938l-1.537-3.93v3.93H5.618l-.41-1.124H3l-.408 1.123H1.437l1.9-5.015Zm14.72 0h-4.263v5.013h4.197l1.352-1.661 1.304 1.661h1.363l-1.98-2.492 1.98-2.521h-1.304l-1.345 1.642-1.304-1.642ZM4.105 9.84l-.728 2.004h1.455L4.105 9.84Zm10.74 1.106v-.916h2.66l1.161 1.464-1.212 1.473h-2.608v-1h2.325v-1.02h-2.325Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};